import * as C from './styles';
import { Button } from '../button';
import Aos from 'aos';
import "aos/dist/aos.css"
import { useEffect } from 'react';
type projectType={
    name: string
    img: string
    link: string
}
export const Project = ({name,img,  link }:projectType)=>{
    useEffect(()=>{
        Aos.init({
            duration: 2000
        })
    }, [])
    return(
        <C.Container data-aos="fade-up">
            <div className='project_img'>
                <img src={img} alt={name} />
            </div>
            <div className='container'>
                <h3>{name}</h3>
                <Button primary text='see it' onclickHandle={()=>window.open(link)}/>
            </div>
        </C.Container>
    )
}
